import { useEffect } from "react";
import { useMainContext } from "../contexts/main";
import { useWindowSize } from "../hooks/common/useWindowSize";
import MainLayout from "../layouts/MainLayout";
import {MOBILE_SIZE, TABLET_SIZE} from "../constants/common";
import {useParams} from "react-router-dom";
import Desktop from "../components/dashboard/Desktop";
import Tablet from "../components/dashboard/Tablet";
import Mobile from "../components/dashboard/Mobile";
import {useAvailableCoin} from "../services/react-query/useMarketQuery";


const DraggableDashboard = () => {

    const params = useParams()
    const { market, setMarket } = useMainContext()
    const { data: coins } = useAvailableCoin()
    const { width } = useWindowSize()

    useEffect(() => {
        if (params.id?.includes("_") && coins) {
            const coinParams = params.id.split('_')
            if (coinParams.length > 1){
                const coin = coinParams[0].toLowerCase();
                const pair = coinParams[1].toLowerCase();

                const isAvailable = coins.find(c => c.id === coin)
                if (isAvailable) setMarket({coin, pair})
                else setMarket({ coin: coins[0]?.id, pair: 'irt' })
            }
        }
    }, [coins])

    // /* url modification */
    useEffect(() => {
        window.history.replaceState(
            {}, null, `/trade/${market.coin?.toUpperCase()}_${market.pair?.toUpperCase()}`
        )
    }, [market])

    const ActiveDashboard = width > TABLET_SIZE ? Desktop : (
        (width <= TABLET_SIZE && width > MOBILE_SIZE) ? Tablet : Mobile
    )

    return (
        <MainLayout>
            <ActiveDashboard />
        </MainLayout >
    )
}

export default DraggableDashboard;



